import { render, staticRenderFns } from "./RingProgAvatar.vue?vue&type=template&id=8f84ca8c&scoped=true&"
import script from "./RingProgAvatar.vue?vue&type=script&lang=js&"
export * from "./RingProgAvatar.vue?vue&type=script&lang=js&"
import style0 from "./RingProgAvatar.vue?vue&type=style&index=0&id=8f84ca8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f84ca8c",
  null
  
)

export default component.exports